module.exports = __webpack_public_path__ + "static/media/sample_customer_upload.b78c711a.csv";